import { Fragment } from "react";

import useOrgUnitAdminRelayEntries from './UseOrgUnitAdminRelayEntries';

import OrgUnitAdminRelayEntriesGrid from "./OrgUnitAdminRelayEntriesGrid";

import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

import Constants from "@usas/ui-web/utils/Constants";

const OrgUnitAdminRelayEntriesReadOnly = () => {
    const { omeMeetOrgUnitAthleteEntryRelayRosterEntryState, onEditRelayClicked } = useOrgUnitAdminRelayEntries();

    return (
        <Fragment>
            <div className="row">
                <div className="col-xs-12">
                    <OrgUnitAdminRelayEntriesGrid
                        gridData={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.arrayData}
                        isLoading={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading}
                        onEditEventClicked={onEditRelayClicked}
                    />
                </div>
            </div>
            <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading} />
            <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.SAVING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isSaving} />
        </Fragment>
    )
}
export default OrgUnitAdminRelayEntriesReadOnly;